<app-job-header></app-job-header>
<div class="job-view-container">
    <h2>Viewing Job from Vibgyor School</h2>
    <!-- Job Details Header -->
    <div class="job-header">
        <div class="job-header-content">
            <div class="school-logo">
                <img src="https://inforidain.blr1.cdn.digitaloceanspaces.com/641d7b024cb4ffd88c6a8611/school_logo/amgx6g1dbbij3wzkf2nc.jpg"
                    alt="School Logo">
            </div>
            <div class="job-title">
                <p class="school-name">Vibgyor School</p>
                <h4>Middle School Teacher - English</h4>
                <p class="job-info">
                    <span>
                        <mat-icon>location_on</mat-icon> Lucknow, Uttar Pradesh
                    </span>
                    <span><mat-icon>schedule</mat-icon> Full time</span>
                    <span><mat-icon>payments</mat-icon> ₹38-40k</span>
                    <span><mat-icon>calendar_today</mat-icon> 4 days ago</span>
                </p>
            </div>
            <button mat-raised-button color="primary" class="apply-button">Apply now</button>
        </div>

    </div>

    <div class="wa-container">
        <div class="whatsapp-section">
            <div class="whatsapp-card">
                <div class="whatsapp-icon">
                    <img src="../../assets/images/whatsappicon.svg" alt="WhatsApp Icon">
                </div>
                <div class="whatsapp-text">
                    <h3>Stay connected and informed!</h3>
                    <p>Join our WhatsApp community for exclusive updates, promotions, and more</p>
                </div>
                <a href="https://chat.whatsapp.com/EDdRZIoKcBZ3MGMCe9mCid" target="_blank" mat-raised-button
                    color="primary" class="join-now-button">Join Now</a>
            </div>
        </div>
    </div>
    

    <!-- Main Content -->
    <div class="content-wrapper">
        
        <!-- Job Description -->
        <div class="job-description">
            <h2>Job Summary</h2>
            <p>[School Name] is seeking a dedicated and passionate Secondary Science Teacher...</p>

            <h3>Key Responsibilities</h3>
            <ul>
                <li>Teach Science subjects (Physics, Chemistry, Biology) to students in Grades 6-10 according to the
                    CBSE curriculum.</li>
                <li>Utilize instructional techniques and technologies to enhance student learning.</li>
                <li>Design and administer assessments to evaluate student progress.</li>
                <li>Maintain a well-organized and disciplined classroom environment.</li>
                <li>Communicate regularly with parents and guardians regarding student progress.</li>
                <li>Participate in professional development opportunities to enhance teaching skills.</li>
            </ul>

            <h3>Qualifications</h3>
            <ul>
                <li>Bachelor's or Master's degree in Science (Physics, Chemistry, Biology).</li>
                <li>2-3 years of teaching experience in a secondary school setting.</li>
                <li>Strong knowledge of the CBSE curriculum and educational standards.</li>
                <li>Valid teaching certification as per CBSE norms.</li>
            </ul>

            <h3>Personal Attributes</h3>
            <ul>
                <li>Passionate about teaching and inspiring students.</li>
                <li>Patient, adaptable, and able to handle diverse student needs.</li>
                <li>Strong problem-solving skills and the ability to think creatively.</li>
            </ul>

            <h3>Application Process</h3>
            <p>Interested candidates should submit a resume, cover letter, and copies of relevant certifications...</p>
        </div>

        <!-- Sidebar: Suggested Jobs -->
        <div class="sidebar">
            <h3>Jobs you might be interested in</h3>
            <mat-card *ngFor="let job of suggestedJobs" class="suggested-job">
                <div class="job-info">
                    <p>{{ job.title }}</p>
                    <p>{{ job.school }}</p>
                    <p>{{ job.location }}</p>
                    <p>{{ job.postedDaysAgo }} days ago</p>
                </div>
                <hr>
            </mat-card>
        </div>
    </div>

    <!-- School Information Section -->
    <div class="school-info">
        <h3>About [School Name]</h3>
        <p>The school was conceptualized in the year 1981 to impart quality education...</p>
    </div>
</div>
<app-job-footer></app-job-footer>